import { getRowSlots, getSectionNote, getSectionRepeat } from '@chordbaker/music-theory';
import { SectionState } from '../types';

/**
 * Checks if a chord sheet is empty (default state with no content)
 * A sheet is considered empty if:
 * - No title
 * - Only one section with no title, repeat or note
 * - Only one row with exactly two slots
 * - All slots are empty (no chords)
 */
export const isChordSheetEmpty = (title: string, sections: SectionState[]): boolean => {
  if (title.trim() !== '') {
    return false;
  }

  if (sections.length !== 1) {
    return false;
  }

  const section = sections[0];
  if (section.title.trim() !== '' || section.rows.length !== 1) {
    return false;
  }

  if (getSectionRepeat(section) !== null || getSectionNote(section) !== null) {
    return false;
  }

  const slots = getRowSlots(section.rows[0]);
  if (slots.length !== 2) {
    return false;
  }

  // Check if all slots are empty (no chords)
  const areAllSlotsEmpty = slots.every(slot => slot.chord === null);

  return areAllSlotsEmpty;
};
